import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const reauthIntegrationFeatureFlag: FeatureFlagType = {
  name: 'reauth-integration',
  fallback: false,
};

export const useIsReauthIntegrationEnabled = () => {
  const [, isEnabled] = useFeatureFlag(reauthIntegrationFeatureFlag);

  return isEnabled;
};
